export default __webpack_public_path__ + "static/media/character-takanobu.7679462c.png";